import { createSerializableStateInvariantMiddleware } from 'redux-starter-kit';
import { Middleware, Dispatch, compose, createStore, applyMiddleware } from 'redux';
import { createNovelsMiddleware } from './middlewares/novels';
import { createAppNovels, addAppNovels } from './novels';
import { StoreState } from './state';
import { Action } from './actions';
import { toggleFeature, ActionType } from './actions/feature';
import { createPersistMiddleware } from './middlewares/persist';
import { reducer } from './reducers';
import { restore } from './actions/persistence';
import { createAppServices } from '../app.services';
import { Features } from '../models/features';

export function createReduxStore() {
  const novelsMiddleware = createNovelsMiddleware<StoreState, Action>(
    (err, action, novel) => {
      console.warn(
        `Error '${err.message}' raised by novel '${novel.name}', triggered on action '${action.type}'`,
      );
      throw err;
    },
  );

  const persistenceMiddleware = createPersistMiddleware<StoreState>(
    {
      set: (item: Partial<StoreState>) => localStorage.setItem('features-flags', JSON.stringify(item)),
      get: (): Partial<StoreState> => JSON.parse(localStorage.getItem('features-flags') || '{}'),
    },
    ActionType.TOGGLE_FEATURE,
    'features',
  );

  let middleware: Middleware<{}, StoreState, Dispatch<Action>>[] = [
    novelsMiddleware,
    persistenceMiddleware,
  ];

  if (process.env.NODE_ENV !== 'production') {
    const createImmutableStateInvariantMiddleware = require('redux-immutable-state-invariant')
      .default;

    middleware = [
      createImmutableStateInvariantMiddleware(),
      ...middleware,
      createSerializableStateInvariantMiddleware(),
    ];
  }

  (window as any).toggleFeature = (feature: Features) => {
    store.dispatch(toggleFeature(feature));
  };

  (window as any).Features = Features;

  const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(
    reducer,
    composeEnhancers(
      applyMiddleware(...middleware),
    ),
  );

  const appServices = createAppServices(store);
  const appNovels = createAppNovels(appServices);

  addAppNovels(novelsMiddleware, appNovels);

  store.dispatch(restore());

  return {
    store,
    appServices,
  };
}
